// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationItem-root-3_HhP","anchor":"NavigationItem-anchor-3bABb","active":"NavigationItem-active-34qBa"};